import { HeaderCell } from 'rsuite-table';

export default HeaderCell;
